<template>
    <div class="login">
        <!--<h1>Login page</h1>-->
        <div>
            <!--<h2>Please provide the following information to access this site</h2>
    token: GUID<br />
    AppID: 27-->
            <h2 style="font-style:italic">Loading...</h2>
        </div>       
    </div>
</template>
<script>
    export default {
        name: 'LoginPage',
        data() {
            return {
                accessToken: '',
                applicationId: '',
                submitted: false
            }
        },
       
        created() {
            // Reset login status
            this.$store.dispatch('Authentication/logout');
            
            this.handleSubmit()
        },
        mounted() {
            this.$store.dispatch('Authentication/checkAuthentication');
        },
        methods: {
            handleSubmit() {
                this.submitted = true;
                this.accessToken = this.$route.query.accessToken;
                if (this.accessToken != '') {
    
                    this.$store.dispatch('Authentication/createCookie', {
                        cookieName: "TokenId",
                        cookieValue: this.accessToken,
                        path: "/"});
                }
                else
                    this.accessToken = this.$store.getters['Authentication/getAccessTokenFromCookie'];
                this.applicationId = `${process.env.VUE_APP_PORTAL_ID}`;
                const { accessToken, applicationId } = this;
                if (accessToken && applicationId)
                {
                    this.$store.dispatch('Authentication/login', { accessToken, applicationId });
                }
            }
        }
    };
</script>
<style>
    .login {
        margin-top: 10%;
        width: 100%;
        text-align: center;
    }

    p, a {
        font-size: 1em;
    }
</style>